export const validateEmail = (email: string) => {
  const reg =
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const value = email || '';
  if (reg.test(value.toString())) {
    if (value.match(/[æøå]/gi)) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};
